import { useEffect, useState } from 'react';
import { recordBug } from '../lib/bugReports';

/**
 * "Fehler merken" — one tap, no questions during the training. Captures the
 * screen before / now / in ~4 s for the debug recording; the referee
 * describes the bug after the training.
 */
export function BugButton({
  sessionId,
  screen,
  context,
}: {
  sessionId: string;
  screen: string;
  context?: Record<string, unknown>;
}) {
  const [confirmed, setConfirmed] = useState(false);
  useEffect(() => {
    if (!confirmed) return;
    const t = setTimeout(() => setConfirmed(false), 2_500);
    return () => clearTimeout(t);
  }, [confirmed]);
  return (
    <>
      <button
        type="button"
        onClick={() => {
          recordBug({ sessionId, screen, ...(context ? { context } : {}) });
          setConfirmed(true);
        }}
        aria-label="Fehler merken"
        title="Fehler merken – beschreiben nach dem Training"
        className="rounded-full border border-zinc-700 px-2 py-0.5 text-sm hover:bg-zinc-800"
      >
        🐞
      </button>
      {confirmed && (
        <div
          role="status"
          className="fixed inset-x-4 top-16 z-50 rounded-lg bg-zinc-800 px-4 py-3 text-sm text-zinc-100 shadow-lg"
        >
          Fehler gemerkt ✓ — bitte nach dem Training kurz beschreiben.
        </div>
      )}
    </>
  );
}
